import React from 'react'
import { Bar } from 'react-chartjs-2';
import { Button, Row} from "reactstrap";
import { CSVLink } from "react-csv";

const ChartBar = ({ title = '', data })  => {
    const options = {
        responsive : true,
        plugins: {
            legend: {  position: 'top' },
            title: {
                display: true,
                text: `${title}`
            },
            datalabels: {
                display: true,
                color: 'black',
                anchor:'end',
                align:'top',
                font: {
                    size: 12,
                    weight:'bold'
                }
            }
        },

    }

    return <Bar data={ data }
        options={ options }
    />
}
const CardChartBar = ({ title, rawData, headers, graphicData, exportCSV = true }) => <div className={'form-container'}>
    <div className={''}>
        <h2>{title}</h2>
        {
            exportCSV && <div className="float-right">
                <CSVLink
                    data={rawData}
                    headers={headers}
                    filename={`${title}.csv`}
                >
                    <Button
                        outline color="primary"
                        size="sm"
                        className="btn-cancel ml-2"
                    >
                        <i className="fa-solid fa-download"/>CSV
                    </Button>
                </CSVLink>
            </div>
        }
    </div>
    <div className={''}>
        <Row>
            <ChartBar title={''} data={graphicData}/>
        </Row>
    </div>
</div>

export {
    CardChartBar
}